/**
 * Notification API Client
 * API calls for manager notifications
 */

import { apiFetch } from '../lib/api';

export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  referenceType: string | null;
  referenceId: string | null;
  acknowledgedAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unacknowledgedCount: number;
}

export interface NotificationCountResponse {
  count: number;
}

/**
 * Get notifications for current manager
 */
export async function getNotifications(params?: {
  acknowledged?: boolean;
  type?: string;
  limit?: number;
}): Promise<NotificationsResponse> {
  const searchParams = new URLSearchParams();
  if (params?.acknowledged !== undefined) {
    searchParams.set('acknowledged', String(params.acknowledged));
  }
  if (params?.type) {
    searchParams.set('type', params.type);
  }
  if (params?.limit) {
    searchParams.set('limit', String(params.limit));
  }

  const query = searchParams.toString();
  const url = `/landlord/api/notifications${query ? `?${query}` : ''}`;

  return apiFetch<NotificationsResponse>(url);
}

/**
 * Get unacknowledged notification count
 */
export async function getNotificationCount(): Promise<NotificationCountResponse> {
  return apiFetch<NotificationCountResponse>('/landlord/api/notifications/count');
}

/**
 * Acknowledge a notification
 */
export async function acknowledgeNotification(notificationId: string): Promise<void> {
  await apiFetch<void>(`/landlord/api/notifications/${notificationId}/acknowledge`, {
    method: 'POST',
  });
}

/**
 * Acknowledge all notifications
 */
export async function acknowledgeAllNotifications(): Promise<{ acknowledged: number }> {
  return apiFetch<{ acknowledged: number }>('/landlord/api/notifications/acknowledge-all', {
    method: 'POST',
  });
}
